// @flow

import * as React from 'react';
import * as Prism from 'prismjs';

export const useHighlightElement = () => {
  const ref = React.useRef<HTMLElement | null>(null);

  React.useLayoutEffect(() => {
    if (ref.current) {
      Prism.highlightElement(ref.current);
    }
  });

  return ref;
};
